import React from 'react';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// import { ReactComponent as HighIcon } from '../../assets/Images/high_cylinder.svg';
// import { ReactComponent as LowIcon } from '../../assets/Images/low_cylinder.svg';
// import { ReactComponent as MediumIcon } from '../../assets/Images/medium_cylinder.svg';

const CustomerTableRow = ({ loading, results, error, path, btnClass }) => {
  return (
    <tbody>
      {loading && (
        <tr className="py-3">
          <td colSpan={3}>
            <div className="d-flex justify-content-center w-100">
              <Spinner className="spinner" animation="border" variant="dark" />
            </div>
          </td>
        </tr>
      )}
      {error && (
        <tr>
          <td colSpan={3} className="w-100 text-center">
            {error}
          </td>
        </tr>
      )}
      {results &&
        results.length > 0 &&
        results.map((customer) => (
          <tr key={customer.customer_id}>
            <td>{`${customer.firstname} ${customer.lastname}`}</td>
            <td>{customer.phone}</td>
            {/* <td> */}
            {/*  {customer.performance === 'high' && <HighIcon />} */}
            {/*  {customer.performance === 'low' && <LowIcon />} */}
            {/*  {customer.performance === 'medium' && <MediumIcon />} */}
            {/* </td> */}
            <td>
              <Link to={`${path}/${customer.customer_id}`} className={`w-100 btn ${btnClass}`}>
                View
              </Link>
            </td>
          </tr>
        ))}
      {!loading && results && results.length === 0 && (
        <tr>
          <td colSpan={3} className="w-100 text-center">
            No Data
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default CustomerTableRow;
